import "../styles/Header.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [certificationsOpen, setCertificationsOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);


  return (
    <header className="header">
      <Link to="/" className="header-logo-link">
        <img
          src="/Assets/logo_hyve.png"
          alt="Logo Le Hyve"
          className="header-logo"
        />
      </Link>
      

      <button
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        type="button"
        aria-label="Ouvrir le menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
        <Link to="/CQPIF">CQPIF</Link>
        <div
          className="dropdown"
          onMouseEnter={() => setCertificationsOpen(true)}
          onMouseLeave={() => setCertificationsOpen(false)}
        >
          <button
            type="button"
            className="dropdown-btn"
            onClick={() => setCertificationsOpen(!certificationsOpen)}
          >
            CERTIFICATIONS
          </button>

          <div className={`dropdown-menu ${certificationsOpen ? "show" : ""}`}>
            <Link to="/certificationMat">PILATES MAT</Link>
            <Link to="/certificationReformer">PILATE REFORMER</Link>
            <Link to="/certification">BOOTCAMP</Link>
          </div>
        </div>
        <Link to="/masterclass">MASTERCLASS</Link>
        <Link to="/inscription">INSCRIPTION</Link>
        <Link to="/lehyve">LE HYVE</Link>
        <Link to="/faq">FAQ</Link>
        <Link to="/contact">CONTACT</Link>
      </nav>
    </header>
  );
}